import { ContainerModule } from "inversify";
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import HotspotQuestionComponent from "./hotspot-question-component.vue";
import { HotspotQuestionAnswerProtobufSerializer } from "./hotspot-question-answer-protobuf-serializer";

export const hotspotQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(HotspotQuestionComponent)
    .whenTargetNamed("hotspot");

    bind(SerializationApi.StateSerializationPluginSymbol).to(HotspotQuestionAnswerProtobufSerializer)
});
